import Icon from '../components/Icon.vue'

Icon.register({"drumstick-bite":{"width":512,"height":512,"paths":[{"d":"M462.8 49.6C396.7-16.5 289.4-16.5 223.3 49.6 187.8 85 160.1 128 160.1 192V277.8L119.5 318.4C109.8 328.1 95.5 329.5 82.7 324.4 61 315.7 35.3 320.1 17.7 337.7-5.9 361.3-5.9 399.5 17.7 423.1 33 438.4 54.2 442.7 73.8 438.2 69.3 457.8 73.7 479 88.9 494.3 112.5 517.9 150.8 517.9 174.4 494.3 192 476.7 196.4 451.1 187.7 429.3 182.7 416.6 184 402.3 193.7 392.6L234.3 352H320.2C343.4 352 363.8 348.3 382.1 342 342.5 298.1 342.3 231.7 383.2 190.9 417.6 156.5 469.9 151.4 511.9 174.1 513.2 129.2 497.1 83.9 462.8 49.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/drumstick-bite.js
// module id = null
// module chunks = 